import './lazyload';
import './layout/menu';
import './layout/search';
import './layout/footer';
import './layout/header';
import './layout/dynamicShelf';
import './widgets';


console.log('🧩 window.aguadecoco', window.aguadecoco);
